import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { WOW } from "wowjs";
import { Col, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import placeholder from "../../assets/images/customplaceholder.png";
import formatIPFS from "../../helpers/formatIPFS";
import "../LetsBrowseScreen/robotCard.css";
import LiveName from "../LiveName";
import { fetchLRToken } from "src/apis";
import axios from "axios";
import { alchemy } from "src/apis/alchemyToken";

const RobotCard = ({ robot, project, filter, contractAddress, count }) => {
  const [tokenDetails, setTokenDetails] = useState({
    collectionName: null,
    imageURI: null,
  });

  useEffect(() => {
    new WOW({
      mobile: false,
      live: false,
    }).init();
  }, []);

  useEffect(() => {
    async function getCollectionName() {
      if (robot.contractAddress && robot.tokenId) {
        try {
          const res = await fetchLRToken(robot.contractAddress, robot.tokenId);
          setTokenDetails({
            collectionName: res?.data?.collection?.name,
            imageURI: res?.data?.imageURI,
          });
        } catch (error) {
          console.log(error);
        }
      }
    }

    getCollectionName();
  }, [contractAddress, robot.contractAddress, robot.tokenId]);

  const renderRef = useRef(0);

  async function fetchOsToken() {
    try {
      let res = await axios.get(
        `https://api.opensea.io/api/v1/asset/${robot.contractAddress}/${robot.tokenId}/?include_orders=false`
      );

      if (res.status === 200 && res.data) {
        return res.data.image_url;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchAlchemyToken() {
    try {
      let res = await alchemy.nft.getNftMetadata(
        robot.contractAddress,
        robot.tokenId
      );
      res = res.media[0]?.raw;
      if (res && res.toLowerCase().indexOf("ipfs")) {
        res = formatIPFS(res);
      }

      return res;
    } catch (error) {
      console.log(error);
    }
  }
  let url = tokenDetails.imageURI || robot.img || robot.imageUrl || robot.image;

  if (url) {
    formatIPFS(url);
  }
  if (!url) {
    url = placeholder;
  }
  const savedUrl = url.indexOf("lh3") > -1;
  if (savedUrl) {
    url = url + "=w300";
  }

  let id = robot.tokenId;
  if (id !== undefined && id.length > 10) id = id.slice(0, 8) + "...";
  const linkState = {
    robot: { ...robot, project: project, filter: filter },
  };
  let showProject = true;

  let projectToUse =
    tokenDetails.collectionName ||
    robot.project ||
    robot.collectionName ||
    project ||
    "NFTR";

  return (
    <Col
      lg={3}
      md={6}
      sm={6}
      xs={6}
      className="text-center wow fadeInUp "
      data-wow-delay={"0." + Math.round(count / 4) + "s"}
    >
      <div className="robot-card">
        <div className="robot-image-border">
          <Link
            to={{
              pathname: `/robot-details/${contractAddress}/${robot.tokenId}`,
              state: linkState,
            }}
          >
            <Image
              className="punk"
              src={url}
              onError={async function (error) {
                renderRef.current++;
                setTimeout(async () => {
                  if (renderRef.current === 1) {
                    error.target.src = await fetchOsToken();
                  } else if (renderRef.current === 2) {
                    error.target.src = await fetchAlchemyToken();
                  } else if (renderRef.current === 3) {
                    error.target.src = placeholder;
                  }
                }, 50);
              }}
            />
          </Link>
        </div>
        <div className="robot-text">
          <LiveName
            contractAddress={contractAddress}
            tokenId={robot.tokenId}
            updateInterval={60000}
          />
          {showProject && projectToUse.length < 21 ? (
            <h3 className="text-pink">{projectToUse}</h3>
          ) : showProject && projectToUse.length > 21 ? (
            <ProjectTooltip projectToUse={projectToUse} />
          ) : null}
          <h4 className="text-green">ID {id}</h4>
        </div>
      </div>
    </Col>
  );
};

export default RobotCard;

function ProjectTooltip({ projectToUse }) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {projectToUse}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <h3 className="text-pink">{`${projectToUse.substring(0, 21)}...`}</h3>
    </OverlayTrigger>
  );
}
